export default "__VITE_ASSET__B2TTJtA9__"